/**
 * Serverzeit im Browser.
 *
 * Gespeicherte Stempel kommen immer vom Server und sind damit korrekt. Die
 * *laufenden* Anzeigen — „Arbeitszeit heute“, „Pause heute“ — müssen dagegen
 * fortlaufend gegen eine Jetzt-Zeit gerechnet werden, und `Date.now()` ist im
 * Browser schlicht das, was die Uhr des Geräts behauptet.
 *
 * Beim Test dieser Anwendung lag ein Rechner 59 Minuten vor dem Server. Der
 * Stempel war trotzdem richtig, die laufende Pause zeigte aber 58 Minuten
 * statt einer. Deshalb wird der Versatz einmal bestimmt und danach jede
 * laufende Dauer gegen `serverNow()` gerechnet.
 *
 * Bewusst kein Versuch, die Netzlaufzeit herauszurechnen: die halbe
 * Umlaufzeit liegt im Bereich von Zehntelsekunden, und für eine Anzeige in
 * Minuten ist das bedeutungslos.
 */

let offset = 0;
let synced = false;

/** Abweichung der Geräteuhr von der Serverzeit, in Millisekunden. */
export const clockOffset = (): number => offset;

/**
 * Setzt den Versatz aus einer bekannten Serverzeit.
 * Wird sowohl vom Abgleich als auch von jeder Stempel-Antwort gefüttert.
 */
export function adoptServerTime(serverNowMs: number): void {
  if (!Number.isFinite(serverNowMs) || serverNowMs <= 0) return;
  offset = serverNowMs - Date.now();
  synced = true;
}

/**
 * Die aktuelle Zeit, so wie der Server sie sieht.
 *
 * Fällt der Abgleich aus, bleibt der Versatz null und es gilt die Geräteuhr —
 * eine falsche laufende Anzeige ist immer noch besser als eine leere.
 */
export const serverNow = (): number => Date.now() + offset;

/** Ab welchem Versatz die Abweichung dem Benutzer gezeigt wird. */
export const SKEW_WARN_MS = 2 * 60 * 1000;

export const hasRelevantSkew = (): boolean => synced && Math.abs(offset) >= SKEW_WARN_MS;
